import './style.css';

import React from "react";

import mock from '../../assets/images/shop/mock.webp';
import mock3 from '../../assets/images/shop/mock3.webp';

import prod1 from '../../assets/images/content/prod1.avif';
import prod2 from '../../assets/images/content/prod2.avif';
import prod3 from '../../assets/images/content/prod3.avif';
import prod4 from '../../assets/images/content/prod4.avif';
import prod5 from '../../assets/images/content/prod5.avif';
import prod6 from '../../assets/images/content/prod6.avif';
import prod7 from '../../assets/images/content/prod7.avif';
import prod8 from '../../assets/images/content/prod8.avif';
import prod9 from '../../assets/images/content/prod9.avif';
import prod10 from '../../assets/images/content/prod10.avif';
import prod11 from '../../assets/images/content/prod11.avif';
import prod12 from '../../assets/images/content/prod12.avif';
import prod13 from '../../assets/images/content/prod13.avif';
import prod14 from '../../assets/images/content/prod14.avif';


const Shop = () => {
    return (
        <div>
            <div className="shop_header">

            </div>
            <div>
                <div className="contain">
                    <div>
                        <h4>Virtual Store Tours</h4>
                        <div>
                            <div className="grid_6">
                                <div className="furniture_content">
                                    <div className="furniture_content_header">
                                        <img src={prod1} alt="prod" />
                                    </div>
                                    <div>
                                        <div className="grid_flex no_align">
                                            <div>
                                                <h4>Arden Velvet Chair</h4>
                                                <p>NGN 8,200</p>
                                            </div>
                                            <div>
                                                <ion-icon name="heart-outline"></ion-icon>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="furniture_content">
                                    <div className="furniture_content_header">
                                        <img src={prod2} alt="prod" />
                                    </div>
                                    <div>
                                        <div className="grid_flex no_align">
                                            <div>
                                                <h4>Arden Velvet Chair</h4>
                                                <p>NGN 8,200</p>
                                            </div>
                                            <div>
                                                <ion-icon name="heart-outline"></ion-icon>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="furniture_content">
                                    <div className="furniture_content_header">
                                        <img src={prod3} alt="prod" />
                                    </div>
                                    <div>
                                        <div className="grid_flex no_align">
                                            <div>
                                                <h4>Arden Velvet Chair</h4>
                                                <p>NGN 8,200</p>
                                            </div>
                                            <div>
                                                <ion-icon name="heart-outline"></ion-icon>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="furniture_content">
                                    <div className="furniture_content_header">
                                        <img src={prod4} alt="prod" />
                                    </div>
                                    <div>
                                        <div className="grid_flex no_align">
                                            <div>
                                                <h4>Arden Velvet Chair</h4>
                                                <p>NGN 8,200</p>
                                            </div>
                                            <div>
                                                <ion-icon name="heart-outline"></ion-icon>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="furniture_content">
                                    <div className="furniture_content_header">
                                        <img src={prod5} alt="prod" />
                                    </div>
                                    <div>
                                        <div className="grid_flex no_align">
                                            <div>
                                                <h4>Arden Velvet Chair</h4>
                                                <p>NGN 8,200</p>
                                            </div>
                                            <div>
                                                <ion-icon name="heart-outline"></ion-icon>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="furniture_content">
                                    <div className="furniture_content_header">
                                        <img src={prod6} alt="prod" />
                                    </div>
                                    <div>
                                        <div className="grid_flex no_align">
                                            <div>
                                                <h4>Arden Velvet Chair</h4>
                                                <p>NGN 8,200</p>
                                            </div>
                                            <div>
                                                <ion-icon name="heart-outline"></ion-icon>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <img src={mock} className="banner" alt="mock" />
                    <div>
                        <h4>Virtual Store Tours</h4>
                        <div>
                            <div className="grid_6">
                                <div className="furniture_content">
                                    <div className="furniture_content_header">
                                        <img src={prod7} alt="prod" />
                                    </div>
                                    <div>
                                        <div className="grid_flex no_align">
                                            <div>
                                                <h4>Arden Velvet Chair</h4>
                                                <p>NGN 8,200</p>
                                            </div>
                                            <div>
                                                <ion-icon name="heart-outline"></ion-icon>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="furniture_content">
                                    <div className="furniture_content_header">
                                        <img src={prod8} alt="prod" />
                                    </div>
                                    <div>
                                        <div className="grid_flex no_align">
                                            <div>
                                                <h4>Arden Velvet Chair</h4>
                                                <p>NGN 8,200</p>
                                            </div>
                                            <div>
                                                <ion-icon name="heart-outline"></ion-icon>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="furniture_content">
                                    <div className="furniture_content_header">
                                        <img src={prod9} alt="prod" />
                                    </div>
                                    <div>
                                        <div className="grid_flex no_align">
                                            <div>
                                                <h4>Arden Velvet Chair</h4>
                                                <p>NGN 8,200</p>
                                            </div>
                                            <div>
                                                <ion-icon name="heart-outline"></ion-icon>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="furniture_content">
                                    <div className="furniture_content_header">
                                        <img src={prod10} alt="prod" />
                                    </div>
                                    <div>
                                        <div className="grid_flex no_align">
                                            <div>
                                                <h4>Arden Velvet Chair</h4>
                                                <p>NGN 8,200</p>
                                            </div>
                                            <div>
                                                <ion-icon name="heart-outline"></ion-icon>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="furniture_content">
                                    <div className="furniture_content_header">
                                        <img src={prod11} alt="prod" />
                                    </div>
                                    <div>
                                        <div className="grid_flex no_align">
                                            <div>
                                                <h4>Arden Velvet Chair</h4>
                                                <p>NGN 8,200</p>
                                            </div>
                                            <div>
                                                <ion-icon name="heart-outline"></ion-icon>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="furniture_content">
                                    <div className="furniture_content_header">
                                        <img src={prod12} alt="prod" />
                                    </div>
                                    <div>
                                        <div className="grid_flex no_align">
                                            <div>
                                                <h4>Arden Velvet Chair</h4>
                                                <p>NGN 8,200</p>
                                            </div>
                                            <div>
                                                <ion-icon name="heart-outline"></ion-icon>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <img src={mock3} className="banner" alt="mock" />
                    <div>
                        <h4>Virtual Store Tours</h4>
                        <div>
                            <div className="grid_6">
                                <div className="furniture_content">
                                    <div className="furniture_content_header">
                                        <img src={prod13} alt="prod" />
                                    </div>
                                    <div>
                                        <div className="grid_flex no_align">
                                            <div>
                                                <h4>Arden Velvet Chair</h4>
                                                <p>NGN 8,200</p>
                                            </div>
                                            <div>
                                                <ion-icon name="heart-outline"></ion-icon>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="furniture_content">
                                    <div className="furniture_content_header">
                                        <img src={prod14} alt="prod" />
                                    </div>
                                    <div>
                                        <div className="grid_flex no_align">
                                            <div>
                                                <h4>Arden Velvet Chair</h4>
                                                <p>NGN 8,200</p>
                                            </div>
                                            <div>
                                                <ion-icon name="heart-outline"></ion-icon>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="furniture_content">
                                    <div className="furniture_content_header">
                                        <img src={prod1} alt="prod" />
                                    </div>
                                    <div>
                                        <div className="grid_flex no_align">
                                            <div>
                                                <h4>Arden Velvet Chair</h4>
                                                <p>NGN 8,200</p>
                                            </div>
                                            <div>
                                                <ion-icon name="heart-outline"></ion-icon>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="furniture_content">
                                    <div className="furniture_content_header">
                                        <img src={prod4} alt="prod" />
                                    </div>
                                    <div>
                                        <div className="grid_flex no_align">
                                            <div>
                                                <h4>Arden Velvet Chair</h4>
                                                <p>NGN 8,200</p>
                                            </div>
                                            <div>
                                                <ion-icon name="heart-outline"></ion-icon>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="furniture_content">
                                    <div className="furniture_content_header">
                                        <img src={prod6} alt="prod" />
                                    </div>
                                    <div>
                                        <div className="grid_flex no_align">
                                            <div>
                                                <h4>Arden Velvet Chair</h4>
                                                <p>NGN 8,200</p>
                                            </div>
                                            <div>
                                                <ion-icon name="heart-outline"></ion-icon>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="furniture_content">
                                    <div className="furniture_content_header">
                                        <img src={prod3} alt="prod" />
                                    </div>
                                    <div>
                                        <div className="grid_flex no_align">
                                            <div>
                                                <h4>Arden Velvet Chair</h4>
                                                <p>NGN 8,200</p>
                                            </div>
                                            <div>
                                                <ion-icon name="heart-outline"></ion-icon>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <h4>Virtual Store Tours</h4>
                        <div>
                            <div className="grid_6">
                                <div className="furniture_content">
                                    <div className="furniture_content_header">
                                        <img src={prod1} alt="prod" />
                                    </div>
                                    <div>
                                        <div className="grid_flex no_align">
                                            <div>
                                                <h4>Arden Velvet Chair</h4>
                                                <p>NGN 8,200</p>
                                            </div>
                                            <div>
                                                <ion-icon name="heart-outline"></ion-icon>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="furniture_content">
                                    <div className="furniture_content_header">
                                        <img src={prod2} alt="prod" />
                                    </div>
                                    <div>
                                        <div className="grid_flex no_align">
                                            <div>
                                                <h4>Arden Velvet Chair</h4>
                                                <p>NGN 8,200</p>
                                            </div>
                                            <div>
                                                <ion-icon name="heart-outline"></ion-icon>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="furniture_content">
                                    <div className="furniture_content_header">
                                        <img src={prod3} alt="prod" />
                                    </div>
                                    <div>
                                        <div className="grid_flex no_align">
                                            <div>
                                                <h4>Arden Velvet Chair</h4>
                                                <p>NGN 8,200</p>
                                            </div>
                                            <div>
                                                <ion-icon name="heart-outline"></ion-icon>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="furniture_content">
                                    <div className="furniture_content_header">
                                        <img src={prod4} alt="prod" />
                                    </div>
                                    <div>
                                        <div className="grid_flex no_align">
                                            <div>
                                                <h4>Arden Velvet Chair</h4>
                                                <p>NGN 8,200</p>
                                            </div>
                                            <div>
                                                <ion-icon name="heart-outline"></ion-icon>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="furniture_content">
                                    <div className="furniture_content_header">
                                        <img src={prod5} alt="prod" />
                                    </div>
                                    <div>
                                        <div className="grid_flex no_align">
                                            <div>
                                                <h4>Arden Velvet Chair</h4>
                                                <p>NGN 8,200</p>
                                            </div>
                                            <div>
                                                <ion-icon name="heart-outline"></ion-icon>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="furniture_content">
                                    <div className="furniture_content_header">
                                        <img src={prod6} alt="prod" />
                                    </div>
                                    <div>
                                        <div className="grid_flex no_align">
                                            <div>
                                                <h4>Arden Velvet Chair</h4>
                                                <p>NGN 8,200</p>
                                            </div>
                                            <div>
                                                <ion-icon name="heart-outline"></ion-icon>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="furniture_content">
                                    <div className="furniture_content_header">
                                        <img src={prod7} alt="prod" />
                                    </div>
                                    <div>
                                        <div className="grid_flex no_align">
                                            <div>
                                                <h4>Arden Velvet Chair</h4>
                                                <p>NGN 8,200</p>
                                            </div>
                                            <div>
                                                <ion-icon name="heart-outline"></ion-icon>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="furniture_content">
                                    <div className="furniture_content_header">
                                        <img src={prod8} alt="prod" />
                                    </div>
                                    <div>
                                        <div className="grid_flex no_align">
                                            <div>
                                                <h4>Arden Velvet Chair</h4>
                                                <p>NGN 8,200</p>
                                            </div>
                                            <div>
                                                <ion-icon name="heart-outline"></ion-icon>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="furniture_content">
                                    <div className="furniture_content_header">
                                        <img src={prod9} alt="prod" />
                                    </div>
                                    <div>
                                        <div className="grid_flex no_align">
                                            <div>
                                                <h4>Arden Velvet Chair</h4>
                                                <p>NGN 8,200</p>
                                            </div>
                                            <div>
                                                <ion-icon name="heart-outline"></ion-icon>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="furniture_content">
                                    <div className="furniture_content_header">
                                        <img src={prod10} alt="prod" />
                                    </div>
                                    <div>
                                        <div className="grid_flex no_align">
                                            <div>
                                                <h4>Arden Velvet Chair</h4>
                                                <p>NGN 8,200</p>
                                            </div>
                                            <div>
                                                <ion-icon name="heart-outline"></ion-icon>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="furniture_content">
                                    <div className="furniture_content_header">
                                        <img src={prod11} alt="prod" />
                                    </div>
                                    <div>
                                        <div className="grid_flex no_align">
                                            <div>
                                                <h4>Arden Velvet Chair</h4>
                                                <p>NGN 8,200</p>
                                            </div>
                                            <div>
                                                <ion-icon name="heart-outline"></ion-icon>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="furniture_content">
                                    <div className="furniture_content_header">
                                        <img src={prod12} alt="prod" />
                                    </div>
                                    <div>
                                        <div className="grid_flex no_align">
                                            <div>
                                                <h4>Arden Velvet Chair</h4>
                                                <p>NGN 8,200</p>
                                            </div>
                                            <div>
                                                <ion-icon name="heart-outline"></ion-icon>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Shop;